import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FORM_TYPE, KitModel, KitType, MetaData, PROCESS_TYPE, Sensor} from '../../models';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgxSpinnerService} from 'ngx-spinner';
import {AccountService} from '../../account/account.service';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../authentication/auth.service';
import {IDropdownSettings} from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-kit-model-form',
  templateUrl: './kit-model-form.component.html',
  styleUrls: ['./kit-model-form.component.css']
})
export class KitModelFormComponent implements OnInit {
  @Input() kitModel: KitModel;
  @Input() metaData: MetaData;
  @Input() formType;
  @Input() isCloning;
  @Input() isView;
  @Output() getKitModelTrigger = new EventEmitter();
  @Output() hideFormTrigger = new EventEmitter();
  isSubmitted: boolean;
  error;
  dropdownSettings: IDropdownSettings = {};
  formKitModel: FormGroup;
  typesOfKitModel: KitType[];
  processTypes = PROCESS_TYPE;
  sensorsOfKitModel: Sensor[];
  propertiesOfKitModel = [];
  actuatorsOfKitModel = [];
  actionsOfKitModel = [];
  sensors = [];
  actuators;
  propertyCalMethod = ['SUM', 'MIN', 'MAX', 'AVG', 'PREDICT', 'OR', 'AND', 'TIME', 'LATEST', 'ANY','NONE'];
  kitModels = [];
  dropdownList = [];
  isKitModelNameAlreadyExist = false;
  isPropertyOrActionAdded = false;
  isActionAdded = false;
  isRemoved = false;
  errors = {nameError:null, actionError: null, mapError: null}

  constructor(private formBuilder: FormBuilder, private spinner: NgxSpinnerService,
              private accountService: AccountService, private toaster: ToastrService) {
  }

  ngOnInit() {
    this.getKitModels()
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };

    this.sensors = this.metaData.sensors.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    this.actuators = this.metaData.actuators.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });
    this.typesOfKitModel = this.metaData.kitTypes;

    this.formKitModel = this.formBuilder.group({
      // id: [null, Validators.required],
      name: [null, Validators.required],
      // noOfSensors: [null, [Validators.required, Validators.pattern('^[1-9]{1}[0-9]*$')]],
      // noOfProperties: [null, [Validators.required, Validators.pattern('^[1-9]{1}[0-9]*$')]],
      type: ['', Validators.required],
      operations: this.formBuilder.array([]),
      // xtraSensors: this.formBuilder.group({
      lbsEnabled: [null, Validators.required],
      gpsEnabled: [false],
      batteryEnabled: [false],
    });

    this.isSubmitted = false;
    if (this.formType === FORM_TYPE.ADD) {
      this.formKitModel.reset();
      this.formKitModel.patchValue({
        lbsEnabled: false,
        type: this.typesOfKitModel[0] ? this.typesOfKitModel[0].name : ""
      });
      this.sensorsOfKitModel = [];
      this.propertiesOfKitModel = [];
      this.actuatorsOfKitModel = [];
    } else {
      this.formKitModel.reset();
      this.sensorsOfKitModel = this.kitModel.sensors ? this.kitModel.sensors.map(val => {
        return this.sensors.filter(s => s.code === val, 1)[0];
      }) : [];
      this.propertiesOfKitModel = this.kitModel.properties ? this.kitModel.properties
        .map(val => this.sensors.filter(s => s.code === val)[0]) // Map properties to sensor objects
        .sort((a, b) => (a && a.code === "B" ? 1 : b && b.code === "B" ? -1 : 0)) // Move "B" to the end
      : [];
      this.actuatorsOfKitModel = this.kitModel.actuators ? this.kitModel.actuators.map(val => {
        return this.actuators.filter(a => a.code === val, 1)[0];
      }) : [];
      this.actionsOfKitModel = this.kitModel.actions ? this.kitModel.actions.map(val => {
        return this.actuators.filter(a => a.code === val, 1)[0];
      }) : [];
      this.kitModel.properties.forEach(p => {
        this.addOperationsFormGroup(p);
      });
      this.kitModel.operations = this.kitModel.operations.map((operation, index) => {
        operation['sensorNumberList'] = operation['sensorNumberList'].map(sensor => {
          const sensorIndex = typeof sensor === 'number' ? sensor : parseInt(sensor.item_id, 10);
            return {
              item_id: sensorIndex,
              item_text: (this.sensorsOfKitModel[sensorIndex] ? this.sensorsOfKitModel[sensorIndex].name : '') + ' ' + (sensorIndex + 1)
            };
          });
          console.log('operations', operation['sensorNumberList']);
          return operation;
        });
      this.formKitModel.patchValue(this.kitModel);
    }
  }

  getKitModels() {
    this.spinner.show();
    this.accountService.getKitModels().subscribe(response => {
      this.kitModels = response.content;
    }, error => {
      this.spinner.hide();
    }, () => {
      this.spinner.hide();
    });
  }

  checkKitModelName() {
    const enteredName = this.formKitModel.controls.name.value;
    this.isKitModelNameAlreadyExist = this.kitModels.some((model) => model.name.toLowerCase() === enteredName.toLowerCase())
    return this.isKitModelNameAlreadyExist;
  }

  updateKitModel(kitModel) {
    Object.keys(this.formKitModel.controls).forEach((key) => {
        if (typeof kitModel[key] === 'string') {
          kitModel[key] = kitModel[key].trim();
        }
      }
    );

    kitModel.operations.map(operation => {
      if (!Array.isArray(operation.sensorNumberList)) {
        this.errors.mapError = "Map All Properties"
      }
      return;
    });

    console.log(kitModel + '#######');
    this.isSubmitted = true;

    if (!this.formKitModel.valid || !this.isValidOperations()) {
      if (this.propertiesOfKitModel.length === 0 && this.actionsOfKitModel.length === 0) {
        this.isPropertyOrActionAdded = true
        return;
      } else if(this.actuatorsOfKitModel.length !== 0 && this.actionsOfKitModel.length === 0) {
        this.isActionAdded = true
        this.errors.actionError = "An Action should be added"
        return;
      }
      return;
    }


    if (!AuthService.hasNewUserAccess && !this.isSuperUser) {
      this.error = 'You have no permission';
      return;
    }

    // if (this.checkKitModelName() && (this.formType !== 1 || this.isCloning)) {
    //   this.errors.nameError = "Kitmodel Name already exists"
    //   console.log('name already exist')
    //   return;
    // }
    if (this.propertiesOfKitModel.length === 0 && this.actionsOfKitModel.length === 0) {
      this.isPropertyOrActionAdded = true
      return;
    }

    if (this.actuatorsOfKitModel.length !== 0 && this.actionsOfKitModel.length === 0) {
      this.isActionAdded = true
      this.errors.actionError = "An Action should be added"
      return;
    }

    const tempKitModel = JSON.parse(JSON.stringify(kitModel));

    tempKitModel.sensors = this.sensorsOfKitModel.map(sensor => sensor.code);
    tempKitModel.actions = this.actionsOfKitModel.map(action => action.code);
    tempKitModel.actuators = this.actuatorsOfKitModel.map(actuator => actuator.code);
    tempKitModel.properties = this.propertiesOfKitModel.map(property => property.code);
    tempKitModel.noOfSensors = this.sensorsOfKitModel.length;
    tempKitModel.noOfActuators = this.actuatorsOfKitModel.length;
    tempKitModel.noOfProperties = this.propertiesOfKitModel.length;
    tempKitModel.noOfActions = this.actionsOfKitModel.length;
    tempKitModel.operations = tempKitModel.operations.map(operation => {
      operation.sensorNumberList = Array.isArray(operation.sensorNumberList)
        ? operation.sensorNumberList.map(sensor => sensor.item_id)
        : [];
      return operation;
    });
    console.log(tempKitModel.operations);

    this.spinner.show();
    this.error = null;
    if (this.formType === FORM_TYPE.ADD || this.isCloning) {
      this.accountService.createKitModel(tempKitModel).subscribe(response => {
        this.spinner.hide();
        this.toaster.success('Kit Model Created Successfully', 'Success');
        this.getKitModelTrigger.emit(true);
        this.hideForm();
      }, error => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
          this.errors.nameError = this.error;
          this.toaster.error(this.error);
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      });
    } else {
      this.accountService.updateKitModel(this.kitModel.id, tempKitModel).subscribe(response => {
        this.spinner.hide();
        this.toaster.success('Kit Model Updated Successfully', 'Success');
        this.getKitModelTrigger.emit(true);
        this.hideForm();
      }, error => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      });
    }
    this.isSubmitted = false;
  }

  addPropertyToKitModel(index: any) {
    this.addOperationsFormGroup(this.getProperties()[index].name);
    this.propertiesOfKitModel.push(this.getProperties()[index]);
    this.isPropertyOrActionAdded = false
  }

  removePropertyFromKitModel(index: number) {
    this.propertiesOfKitModel.splice(index, 1);
    this.removeOperationsFormGroup(index);
    this.isRemoved = true
  }

  addActionToKitModel(index) {
    this.actionsOfKitModel.push(this.actuatorsOfKitModel[index]);
    this.isPropertyOrActionAdded = false
    this.errors.actionError = null
  }

  removeActionFromKitModel(index) {
    this.actionsOfKitModel.splice(index, 1);
    this.isRemoved = true
  }

  addSensorToKitModel(index) {
    this.sensorsOfKitModel.push(this.sensors[index]);
  }

  removeSensorFromKitModel(index) {
    const sensorName = this.sensorsOfKitModel[index].name;

    this.propertiesOfKitModel = this.propertiesOfKitModel.filter((prop, i) => {
      const shouldRemove = prop.name === sensorName;
      if (shouldRemove) {
        this.removeOperationsFormGroup(i);
      }
      return !shouldRemove;
    });
    this.sensorsOfKitModel.splice(index, 1);
    this.isRemoved = true
  }

  addActuatorToKitModel(index) {
    this.actuatorsOfKitModel.push(this.actuators[index]);
  }

  removeActuatorFromKitModel(index: number) {
    this.actuatorsOfKitModel.splice(index, 1);
    this.isRemoved = true
  }

  addOperationsFormGroup(property) {
    const operations = this.formKitModel.get('operations') as FormArray;
    this.dropdownList = this.sensorsOfKitModel.map((sensor, index) => {
      return {item_id: index, item_text: sensor.name + ' ' + (index + 1)}
    })
    const sensorX = this.dropdownList[this.propertiesOfKitModel.length];
    operations.push(this.formBuilder.group({
      propertyNumber: [this.getPropertyNumber(property), Validators.required],
      sensorNumberList: [sensorX, Validators.required],
      aggregation: [this.getPropertyCalMethod()[0], Validators.required],
      type: [this.processTypes[this.getProcessTypes()[0]], Validators.required],
    }));
  }


  removeOperationsFormGroup(index) {
    const operations = this.formKitModel.get('operations') as FormArray;
    operations.removeAt(index);
    this.isRemoved = true
  }

  getProperties() {
    const properties = [];
    this.sensorsOfKitModel.forEach((val) => {
        if (!properties.includes(val)) {
          if ((val.code === 'MEA' || val.code === 'MEA0' || val.code === 'MEA1' || val.code === 'MEA2' || val.code === 'MEA3' || val.code === 'MEA4')
            && !properties.includes(this.getSensorsByCode('M'))) {
            properties.push(this.getSensorsByCode('M'));
            properties.push(this.getSensorsByCode('CN'));
          } else if ((val.code === 'PHA') && !properties.includes(this.getSensorsByCode('PH'))) {
            properties.push(this.getSensorsByCode('PH'));
          } else {
            properties.push(val);
          }
        }
      }
    );
    return properties;
  }

  getActions() {
    const actions = [];
    this.actuatorsOfKitModel.forEach((val) => {
        if (!actions.includes(val)) {
          actions.push(val);
        }
      }
    );
    return actions;
  }

  getSensorsSelected() {
    this.dropdownList = this.sensorsOfKitModel.map((s, index) => {
      return ({item_id: index, item_text: s.name + ' ' + (index + 1)});
    });
    // return Array.from({length: this.sensorsOfKitModel.length}, (v, k) => String(k));
  }

  getPropertyCalMethod() {
    return this.propertyCalMethod;
  }

  getPropertyNumber(property) {
    console.log(property);
    console.log(property.includes('Battery Level'));
    return property.includes('Battery Level') ? -11 : (property.includes('Battery') ? -10 : this.propertiesOfKitModel.length);
  }

  getProcessTypes() {
    return Object.keys(this.processTypes).map(o => {
      return String(o);
    });
  }

  getWindowWidth() {
    return window.innerWidth;
  }

  hideForm() {
    this.hideFormTrigger.emit(true);
  }

  isSuperUser() {
    return AuthService.isSuperAdmin();
  }

  onItemSelect(item: any) {
    this.errors.mapError = null
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getSensorsByCode(code: string) {
    return this.sensors.filter(s => s.code === code, 1)[0];
  }

  isValidOperations() {
    const formValue = this.formKitModel.value;

    for (let i = 0; i < formValue.operations.length; i++) {
      const sensorNumberList = formValue.operations[i].sensorNumberList;

      // Check if sensorNumberList is a non-empty array
      if (!Array.isArray(sensorNumberList) || sensorNumberList.length === 0) {
        return false;
      }
    }

    return true;
  }

  changesMade(): boolean {
    // Compare the current form value with the original form value
    return this.formKitModel.dirty || this.isRemoved;
  }

}
